import React from "react";
import axios from "axios";
import { useMsal, useAccount } from "@azure/msal-react";

import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import {
  isAuthRequest,
  isGraphRequest,
  requestGraphToken,
  requestToken,
} from "../helpers";

interface RequestInterceptorProps {
  enabled?: boolean;
  children: JSX.Element;
}

export const RequestInterceptor: React.FC<RequestInterceptorProps> = ({
  enabled = true,
  children,
}: RequestInterceptorProps) => {
  const [isInterceptorAdded, setIsInterceptorAdded] = React.useState<boolean>(false);
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0]);

  if (enabled && !isInterceptorAdded) {
    addApiAuthIntercept(account, instance);
    setIsInterceptorAdded(true);
  }

  return <>{children}</>;
};

const addApiAuthIntercept = (
  account: AccountInfo | null,
  instance: IPublicClientApplication
) => {
  axios.interceptors.request.use(async config => {
    if (!config.url) {
      throw Error("No url found in request config.");
    }

    const isApiAuthRequest = isAuthRequest(config.url);
    const isGraphAuthRequest = isGraphRequest(config.url);

    if (isApiAuthRequest || isGraphAuthRequest) {
      const tokenRequest = isApiAuthRequest ? requestToken : requestGraphToken;

      const auth = await tokenRequest(account, instance);

      if (auth) {
        const bearer = `Bearer ${auth.accessToken}`;
        config.headers = config.headers || {};
        config.headers.Authorization = bearer;
      }
    }

    return config;
  });
};
